module.exports = __webpack_public_path__ + "static/media/5DPO4.f36e36f8.jpg";